import { contentName } from "./contentUrl";
import React, { useContext, useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Memberdetail from "../Pages/Member Detail";
import { LanguageContext } from "./LanguageContext";
import { loadMembers, memberPath, memberSlug } from "./memberUrl";

export default function MemberRoute() {
  const { id, slug } = useParams();
  const { selectedLanguage } = useContext(LanguageContext);
  const thai = selectedLanguage === "th";
  const key = id || slug;
  const [state, setState] = useState({ key: null, loading: true });
  useEffect(() => {
    const controller = new AbortController();
    setState({ key, loading: true });
    loadMembers(controller.signal).then((members) => {
      if (controller.signal.aborted) return;
      const matches = members.filter((member) => id ? String(member.id) === id : memberSlug(member) === slug);
      setState({ key, loading: false, member: matches.length === 1 ? matches[0] : null });
    }).catch(() => {
      if (!controller.signal.aborted) setState({ key, loading: false, error: true });
    });
    return () => controller.abort();
  }, [id, slug, key]);
  useEffect(() => {
    if (state.key === key && state.member) document.title = "Team Members / " + contentName(state.member) + " | NX KMUTT";
  }, [state, key]);
  if (state.loading || state.key !== key) return <p role="status" className="p-5">{thai ? "กำลังโหลดข้อมูลสมาชิก…" : "Loading member…"}</p>;
  if (state.error) return <p role="alert" className="p-5">{thai ? "โหลดข้อมูลสมาชิกไม่สำเร็จ กรุณาลองใหม่" : "Unable to load member. Please try again."}</p>;
  if (!state.member) return <main className="p-5"><h1>{thai ? "ไม่พบสมาชิก" : "Member not found"}</h1><Link to="/Team-Members">{thai ? "สมาชิกทั้งหมด" : "All team members"}</Link></main>;
  if (id) return <Navigate to={memberPath(state.member)} replace />;
  return <Memberdetail key={state.member.id} memberId={String(state.member.id)} />;
}
